module.exports = __webpack_public_path__ + "static/img_2067-e9a8c341a40928d2941187e08c8b7cd6.webp";